import { setTimeZoneForDate } from '@codametrix/ui-common/date-time';
import { get, set } from '@codametrix/ui-common/object-utils';

export function loadStateClaim(loadState: CMxCommonApp.Loading, claim: string) {
  return { ...loadState, claim };
}

export function isLoadingClaim(
  loadState: any
): loadState is CMxCommonApp.LoadingClaim {
  return 'claim' in loadState;
}

/**
 * Method to set append appropriate timezone for given patient timeline entry and prop name(with date str)
 * @param entry
 * @param propName
 * @param timeZoneStr
 * @returns
 */
export function setTimeLineEntryPropTimeZone(
  entry: CMxAPI.TimelineEntry,
  propName: string,
  timeZoneStr: CMxAPI.NullableString | undefined
) {
  const propValue = get(entry, propName);
  if (propValue) {
    const parsedDateTime = setTimeZoneForDate(
      timeZoneStr,
      propValue
    );
    set(entry, propName, parsedDateTime);
  }
  return entry;
}
